import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';
import Card from '../ui/Card';

export default function SectionProjet({ data }) {
  const { title, intro, blocks, quote } = data;

  return (
    <section id="projet" className="section-padding bg-black">
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">{title}</h2>
          {intro && (
            <p className="text-xl text-secondary-200 max-w-3xl mx-auto leading-relaxed">
              {intro}
            </p>
          )}
        </motion.div>

        {/* Blocks */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {blocks.map((block, index) => {
            const Icon = Icons[block.icon] || Icons.FileText;

            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <Card hover className="h-full">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="p-3 bg-primary-900/30 text-primary-400 rounded-xl border-2 border-primary-500">
                      <Icon size={24} />
                    </div>
                    <h3 className="text-xl font-bold text-white">{block.title}</h3>
                  </div>
                  <ul className="space-y-2">
                    {block.items.map((item, i) => (
                      <li key={i} className="flex items-start gap-2 text-secondary-200">
                        <span className="text-primary-500 mt-1">•</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </Card>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
